import * as Type from './types'

import { executeCallback, setInMemory } from '@services/store/utils'

const initialState = {
    data: {},
    loaded: null
}

export default function ServiceHealthReducer(state = initialState, action) {
    if (action.type === Type.POPULATE) {
        return executeCallback(
            setInMemory(state, action, 'data'),
            action,
            'serviceHealth'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded'),
            action,
            'serviceHealth'
        )
    }

    return state
}
